<template>
  <div>
    <div class="row" v-if="details === null">
        <div class="col-md-12 p-2 text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
          <h2 class="section__title  mb-5">HDD Files</h2>
      </div>
      <div class="col-12">   
        <div class="card border-0">
          <div class="card-body">
            <div class="row">
                <div class="col-md-12"> 
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb" >   
                      <li class="breadcrumb-item active"  v-for="(breadcrumb, index) in bread_crumbs">
                        <a href="/hdd" v-if="index == 0" >HDD</a>
                        <span v-if="index > 0">
                          
                          <a  :href="'/hdd?folder_id='+breadcrumb.id">{{(breadcrumb.name == 'My Files' ? 'HDD' : breadcrumb.name)}}</a>
                        </span>
                        
                      </li>
                      <li class="breadcrumb-item">
                        {{ details.name }}
                      </li>
                    </ol>
                  </nav> 
                </div>
                <div class="col-12 d-flex justify-content-end mb-2 select_all">
                  <button class="btn --theme-primary --style-xsmall"  data-toggle="modal" data-target="#exportLinksModal"><i class="fas fa-file-export"></i> Export</button>
                  <a :href="details.link" target="_blank"  class="btn --theme-primary --style-xsmall  mx-1"><i class="fas fa-download"></i> Download</a>
                  <button class="btn --theme-primary --style-xsmall"  data-toggle="modal" data-target="#deleteModal"><i class="fas fa-times-circle"></i> Delete </button>
                </div>
                <div  class="col-md-12 mb-4">
                  <div class="row" v-if="details.mime_type.includes('video/')">
                    <div class="col-md-8 offset-md-2 w-100 bg-dark d-flex justify-content-center" v-if="details.transcode_status == 'DISABLEDpending' || details.transcode_status == 'DISABLEDrunning'" style="height:450px;">
                      <h2 class="align-middle align-self-center text-white text-center">This file is still transcoding, please come back later.</h2>
                    </div>
                    <div class="col-md-8 offset-md-2" v-else-if="details.transcode_status == 'good_as_is' || details.transcode_status == 'finished' || details.transcode_status == 'running' || details.transcode_status == 'pending' ">
                      <video-player :options="video_options" :type="details.mime_type" :id="details.id" :hash="details.opensubtitles_hash"/>
                    </div>
                    <div class="col-md-8 offset-md-2 w-100 bg-dark d-flex justify-content-center" v-else style="height:450px;">
                       <h2 class="align-middle align-self-center text-white text-center">Error playing this file, sorry.</h2>
                    </div>
                  </div>
                  <div class="row" v-else-if="details.mime_type.includes('audio/')">
                    <div class="col-md-8 offset-md-2" >
                      <video-player :options="video_options" :type="details.mime_type" :id="details.id" :hash="details.opensubtitles_hash"/>
                    </div>
                  </div>
                  <div class="row" v-else-if="details.mime_type.includes('image/')">
                      <div class="col-md-8 offset-md-2">
                          <img :src="details.link" class="img-fluid w-100"/>
                      </div>
                  </div>
                  <div class="row" v-else-if="details.mime_type.includes('/pdf')">
                    <div class="col-md-8 offset-md-2 w-100 d-flex justify-content-center" style="height: 600px;">
                      <iframe :src="'https://docs.google.com/gview?url='+ details.link + '&embedded=true'" width="100%" height="100%"></iframe>
                    </div>
                  </div>
                  <div class="row" v-else>
                     <div class="col-md-8 offset-md-2 w-100  d-flex justify-content-center">
                        <div class="file-detail align-middle align-self-center text-center">
                          <i class="icon icon-type-file" style="font-size: 100px;"></i>
                        </div>
                     </div>
                  </div>
                </div>
              </div>
            </div>
          </div>     
      </div>
      <div class="modal fade" id="exportLinksModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">Export</div>
               <div class="modal-body text-center">
                  <div class="row pmcard-row">
                    
                    <div class="col-md-12">
                      <textarea rows="5" :value="details.link" class="directlinks form-control" style="white-space: pre;"></textarea>
                    </div>
                  </div>
               </div>
               <div class="modal-footer">
                <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">Close</button>
               </div>
            </div>
         </div>
      </div>
      <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteModalLabel">Confirmation</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
               <p class="text-break-all">Do you really want to delete these item?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary --style-xsmall" data-dismiss="modal">No</button>
              <button type="button" class="btn --theme-primary --style-xsmall" id="delete_item_btn" @click="deleteItem">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import VideoPlayer from "./VideoPlayerComponent.vue";

  export default {
    components: {
      VideoPlayer
    },
    data() {
      return {
        file_id: this.getParameterFromUrl('id'),
        bread_crumbs: {},
        details: null,
        video_options: {},
      };
    },
    filters: {
        humanFileSize: (bytes) => {
            var thresh = 1024;
            if(Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }
            var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while(Math.abs(bytes) >= thresh && u < units.length - 1);
            return bytes.toFixed(1)+' '+units[u];
        },

    },
    mounted() {
      this.fileDetails();
    },
    methods: {
      goBack(link) {
          window.location.href = link; 
      },
      getParameterFromUrl: function(param){
          var result = null,
            tmp = [];
          var items = location.search.substr(1).split("&");
          for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
          }
          return result
      },
      fileDetails(){
        axios.post('/api/item/details',{file_id : this.file_id}).then(response=>{
            this.details = response.data.details;
            this.bread_crumbs = response.data.breadcrumbs;

            this.fileBreadCrumbs(this.details.folder_id);
            if(this.details.mime_type.includes('video/')){

              var live_transcode_server_url = process.env.MIX_LIVETRANSCODE_URL;
              var live_video_url = live_transcode_server_url + this.details.directlink + '/index.m3u8';
              
              var player_link = (this.details.transcode_status == 'good_as_is' ? this.details.link : live_video_url);

              console.log(this.details.transcode_status == 'good_as_is' ? 'good_as_is' : "live_transcode");

              this.video_options = {
                autoplay: false,
                controls: true,
                aspectRatio: "640:360",
                sources: [
                  {
                    src:
                      player_link,
                      type: this.details.transcode_status == 'good_as_is' ? 'video/mp4' : 'application/x-mpegURL'
                  }
                ],
                html5: {
                  hls: {
                    limitRenditionByPlayerDimensions: true,
                    useDevicePixelRatio: true,
                    useNetworkInformationApi: true
                  }
                },
                fluid: true,
                techOrder: [ 'html5', 'chromecast' ],
                plugins: {
                  airPlay: {},
                  chromecast: {}
                }
              };

            } else if(this.details.mime_type.includes('audio/')){

                var player_link = (this.details.stream_link ? this.details.stream_link : this.details.link);

                this.video_options = {
                  controlBar: {
                    fullscreenToggle: false,
                    pictureInPictureToggle: false
                  },
                  sources: [
                    {
                      src:
                        player_link,
                        type: 'audio/mp3'
                    }
                  ],
                };
            }
            

        }).catch(error=>{
          console.log(error);
        });
      },
      fileBreadCrumbs(folder_id){
        axios.post('/api/item/breadcrumbs',{folder_id : folder_id}).then(response=>{
            this.bread_crumbs = response.data.breadcrumbs;
        }).catch(error=>{
          console.log(error);
        });
      },
      deleteItem(){

          var redirect = '/hdd?folder_id='+this.details.folder_id;

          $('#delete_item_btn').attr("disabled", true).html('<i class="fas fa-spinner fa-pulse"></i> Deleting').removeClass('btn-success').addClass('btn-secondary');
          axios.delete('/api/item/delete/'+this.file_id).then(response=>{
            $('#delete_item_btn').attr("disabled", false).html('Yes').removeClass('btn-secondary').addClass('btn-success');
            $('#deleteModal').modal('toggle');
            flash(response.data.message, 'success');
            //redirect to parent folder
            window.location = redirect;

          }).catch(error=>{
              $('#delete_item_btn').attr("disabled", false).html('Yes').removeClass('btn-secondary').addClass('btn-success');
              flash(JSON.parse(error.request.response).message, 'error');
          });
      }
    }
  }
</script>